// @flow
import { compose, withHandlers, mapProps } from 'recompose'
import { withRouter } from 'react-router-dom'
import { formatDateShort } from '../../core/dateFormater'
import { isAuctionPending, isAuctionLive } from '../../services/auction/utils'
import getImageSource from './media/getImageSource'

const withOnViewDetailHandler = withHandlers({
  onViewDetail: props => event => {
    event.preventDefault()
    const link = props.isMyCharity
      ? `/mycharity/auctions/${props.auction.id}`
      : `/auctions/${props.auction.id}`
    props.history.push(link)
  }
})

const withPresentationProps = mapProps(({ auction, onViewDetail }) => ({
  title: auction.title,
  subtitle: formatDateShort(auction.closeTime),
  subsubtitle: `Bids open: ${formatDateShort(auction.startTime)}`,
  caption: auction.location,
  imageUrl:
    getImageSource(auction.photo_thumb) || getImageSource(auction.photo),
  hasStateTag: isAuctionPending(auction) ? false : true,
  tagType: isAuctionLive(auction) ? 'success' : 'info',
  tagText: auction.state,
  onViewDetail
}))

const withAuctionCard = compose(
  withRouter,
  withOnViewDetailHandler,
  withPresentationProps
)

export default withAuctionCard



// WEBPACK FOOTER //
// ./src/services/mycharity/withAuctionCard.js